import { RegistryChatToggle } from './RegistryChatToggle';
import { ToolChatToggle } from './ToolChatToggle';
import type { ChatStatusCellProps } from './types';

export function ChatStatusCell({
  toolRow,
  onToggleEnabledInPrimaryAgent,
  onBulkToggleChatEnabled,
  isBulkToggling,
}: ChatStatusCellProps) {
  if (toolRow.isRegistry) {
    return (
      <RegistryChatToggle
        toolRow={toolRow}
        onBulkToggleChatEnabled={onBulkToggleChatEnabled}
        isLoading={isBulkToggling}
      />
    );
  }

  return (
    <ToolChatToggle
      tool={toolRow.tool}
      onToggleEnabledInPrimaryAgent={onToggleEnabledInPrimaryAgent}
    />
  );
}
